import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "estate-listing estate-listing--grid-md" }
const _hoisted_2 = { class: "estate-listing__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstateAgentReviewRatingGraph = _resolveComponent("EstateAgentReviewRatingGraph")!
  const _component_EstateAgentReviewStarsListItem = _resolveComponent("EstateAgentReviewStarsListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EstateAgentReviewRatingGraph, {
        summary: _ctx.data.summary
      }, null, 8, ["summary"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.reviews, (review, index) => {
      return (_openBlock(), _createBlock(_component_EstateAgentReviewStarsListItem, {
        key: index,
        review: review
      }, null, 8, ["review"]))
    }), 128))
  ]))
}